import React from 'react'
import "../styles/SearchBar.css"

const SearchBar = ({completeConnection, searchQuery, handleSearchChange, connectedActors}) => {
  return (
    <>
    <div className="search-bar-container">
        {!completeConnection && (
          (connectedActors.length < 6 ? 
            (<input className="search-bar" type="text" placeholder="Search for an actor..." value={searchQuery} onChange={handleSearchChange}/>)
            :
            (<h3>Incomplete connection, try in 6 degrees or less.</h3>)
          )
          )}
    </div>
    </>
  )
}

export default SearchBar